import {Link} from 'react-router-dom';
import {useEffect, useState} from 'react';

import MainMenu from './header-menu';
import SideBar from './offcanvas';
import MobileMenuOne from './menu_sidebar/menu-one';
import {getCMSContact, getCMSGeneral} from "../../utils/cms.utils";


const HeaderOne = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [menuSidebar, setMenuSidebar] = useState(false);
    const [isSticky, setIsSticky] = useState(false);

    const [contact, setContact] = useState(null);
    const [general, setGeneral] = useState(null);

    /* =========================
       LOAD CMS DATA
    ========================= */
    useEffect(() => {
        setContact(getCMSContact());
        setGeneral(getCMSGeneral());
    }, []);

    /* =========================
       STICKY HEADER
    ========================= */
    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(window.scrollY > 100);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const logoSrc = isSticky ? general?.logo2 || general?.logo1 : general?.logo1 || general?.logo2;

    return (
        <>
            <div className={`header__area ${isSticky ? "header__sticky-sticky-menu" : ""}`}>
                <div className="custom_container">
                    <div className="header__area-menubar">
                        <div className="header__area-menubar-left one">
                            <div className="header__area-menubar-left-logo">
                                <Link to='/'>
                                    {logoSrc && (
                                        <img
                                            src={logoSrc}
                                            alt="Company Logo"
                                        />
                                    )}
                                </Link>
                            </div>
                        </div>

                        <div className="header__area-menubar-center">
                            <div className="header__area-menubar-center-menu">
                                <MainMenu type={1} isSticky={isSticky}/>
                            </div>
                        </div>

                        <div className="header__area-menubar-right">
                            <div className="header__area-menubar-right-sidebar">
                                <div
                                    className="header__area-menubar-right-sidebar-icon"
                                    onClick={() => setSidebarOpen(true)}
                                >
                                    <i className="flaticon-menu-6"></i>
                                </div>
                            </div>

                            <div className="header__area-menubar-right-responsive-menu menu__bar">
                                <i
                                    className={`flaticon-menu-3 ${isSticky ? "is-sticky" : ""}`}
                                    onClick={() => setMenuSidebar(true)}
                                ></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <SideBar
                isOpen={sidebarOpen}
                setIsOpen={setSidebarOpen}
                contact={contact}
                general={general}
            />

            <MobileMenuOne
                isOpen={menuSidebar}
                setIsOpen={setMenuSidebar}
                isSticky={isSticky}
                general={general}
            />
        </>
    );
};

export default HeaderOne;
